import axios from "axios";
import React from "react";
import { alertRef } from "../../../../App";
import Dropdown from "../../../../Components/Dropdown/Dropdown";
import { Button, Input } from "../../../../Components/StyledComponents";
import { onlyNum } from "../../../../Utils/functions";
import SetSMS from "../../Components/SetSMS/SetSMS";
import SetTarget from "../../Components/SetTarget/SetTarget";
import './PointTarget.scss';

/* **** 
    VisitTarget 참고
    **** */

const typelist = {
    'Total' : '누적',
    'Remain' : '보유'
}

const PointTarget = () => {
    const [ pointType, setPointType ] = React.useState('Total')//포인트 추출 타입 (누적|보유)
    const [ pointStart, setPointStart ] = React.useState(0)//추출 시작 포인트
    const [ pointEnd, setPointEnd ] = React.useState(0)//추출 종료 포인트

    const [ title, setTitle ] = React.useState('');
    const [ text, setText ] = React.useState('');
    const [ coupon, setCoupon ] = React.useState('');
    const [ gender, setGender ] = React.useState([])
    const [ age, setAge ] = React.useState([])
    const [ targetSort, setTargetSort ] = React.useState('');
    const [ reqCount, setReqCount ] = React.useState(0);
    const [ couponInfo, setCouponInfo ] = React.useState({})

    const [ targetCount, setTargetCount ] = React.useState(0);

    const getTarget = () => {
        axios.post('/api/sms/filter',{
            Type : 'Point',
            PointType : pointType,
            FilterRange : { Min : ( pointStart ===0 && pointEnd === 0) ? 'All' : Number(pointStart), Max : ( pointStart ===0 && pointEnd === 0) ? 'All' : Number(pointEnd) },
            Day : 7,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 200){
                setTargetCount(data.data.TargetCount)
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })  
        })
    }

    const sendTargetSMS = () => {
        axios.put('/api/sms/filter',{
            Title : title,
            Body : text,
            Coupon : coupon,
            Type : 'Point',
            PointType : pointType,
            FilterRange : { Min : ( pointStart ===0 && pointEnd === 0) ? 'All' : Number(pointStart), Max : ( pointStart ===0 && pointEnd === 0) ? 'All' : Number(pointEnd) },
            Day : 7,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 204 ){
                alertRef.current.showAlert({ title : `문자 발송이 완료 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }else if(data.status === 200){
                alertRef.current.showAlert({ title : `보유 벨이 부족합니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `네트워크 상태 혹은 보유벨을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className="visit">
            <div className="box">
                <p className="title">포인트</p>

                <div className="row">
                    <Dropdown
                        width={119}
                        options={[
                            { key : '누적', value : 'Total'},
                            { key : '보유', value : 'Remain'},
                        ]}
                        value={typelist[pointType]}
                        onItemClick={(val) => setPointType(val)}
                    />
                    <label htmlFor="pointStart" data-domain="P">
                        <Input
                            id='pointStart'
                            style={{ width : 180, marginLeft : 14 }}
                            value={ pointStart }
                            onChange={(e) => setPointStart(onlyNum(e.target.value))}
                        />
                    </label>
                    <p className="tilde">~</p>
                    <label htmlFor="pointEnd" data-domain="P">
                        <Input
                            id="pointEnd"
                            style={{ width : 180 }}
                            value={ pointEnd }
                            onChange={(e) => setPointEnd(onlyNum(e.target.value))}
                        />
                    </label>
                </div>
            </div>

            <SetTarget gender={gender} setGender={setGender} age={age} setAge={setAge} targetSort={targetSort} setTargetSort={setTargetSort} reqCount={reqCount} setReqCount={setReqCount} getTarget={getTarget} targetCount={targetCount}/>

            <SetSMS smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo}/>

            <Button variant='outline' className="send-btn" disabled={ title.trim() == '' || text.trim() === '' || targetCount === 0} onClick={() => alertRef.current.showAlert({ title : `타겟 문자를 발송할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();sendTargetSMS()} })}>
                문자 발송하기
            </Button>
        </div>
    )
}

export default PointTarget;